// extracted by mini-css-extract-plugin
module.exports = {"d2xZ2":"Z2_d2xZ2__65zoB","delta2maxDash":"Z2_delta2maxDash__1iOrk"};